'use client';

import { createContext, PropsWithChildren, useState } from 'react';
import { EntityTypeCode, ActionType, FormDto } from '@/apiClient';
import {
  TBuilderFieldColumn,
  TFormBuilderContext,
  TSection,
} from '@/model/form-builder';
import { arrayMove } from '@dnd-kit/sortable';

export const FormBuilderContext = createContext<TFormBuilderContext>(
  {} as TFormBuilderContext,
);

export const defaultFormContainers: TSection[] = [
  {
    id: 'row-1',
    title: 'row-1',
    items: {
      'col-1': [],
    },
  },
];

export const FormBuilderProvider = (props: PropsWithChildren) => {
  const [formBasicInfo, setFormBasicInfo] = useState<FormDto>({
    actionType: ActionType.Create,
    entityType: EntityTypeCode.Animal,
    formName: '',
  });

  const [rootItem, setRootItem] = useState<TBuilderFieldColumn>({
    id: 'root',
    items: [],
  });

  const [formContainers, setFormContainers] = useState(defaultFormContainers);

  function swapSections(oldIndex: number, newIndex: number) {
    if (newIndex < 0 || newIndex >= formContainers.length) return;
    setFormContainers((prev) => arrayMove(prev, oldIndex, newIndex));
  }

  return (
    <FormBuilderContext.Provider
      value={{
        rootItem,
        setRootItem,
        formContainers,
        setFormContainers,
        formBasicInfo,
        setFormBasicInfo,
        swapSections,
      }}
    >
      {props.children}
    </FormBuilderContext.Provider>
  );
};
